import React from 'react'
import PropTypes from 'prop-types'
import { renderRichText } from '../../../gutenberg/utils'
import { AnimationOnScroll } from 'react-animation-on-scroll'

import Button from 'scripts/components/Button'

import {
  Wrapper,
  InnerWrapper,
  Index,
  Title,
  Text,
  Image,
} from './custom.styled'

const ContentBox = ({
  isEditor = false,
  index,
  title,
  text,
  image,
  link,
  linkText,
}) => {
  return (
    <Wrapper>
      {index && (
        <AnimationOnScroll
          animateIn="animate__fadeInDown"
          initiallyVisible={isEditor}
        >
          <Index>{renderRichText(index, 'span')}</Index>
        </AnimationOnScroll>
      )}
      <AnimationOnScroll
        animateIn="animate__fadeInUp"
        initiallyVisible={isEditor}
      >
        <InnerWrapper isImage={image.url}>
          {image.url !== null && (
            <Image>
              <img src={image.url} alt={image.title} />
            </Image>
          )}
          {title && <Title>{renderRichText(title, 'span')}</Title>}
          {text && <Text>{renderRichText(text, 'p')}</Text>}
          {link.url && (
            <Button
              title={linkText}
              link={link}
              bgColor="var(--primary)"
              isEditor={isEditor}
            />
          )}
        </InnerWrapper>
      </AnimationOnScroll>
    </Wrapper>
  )
}

ContentBox.propTypes = {
  isEditor: PropTypes.bool,
  image: PropTypes.object,
  index: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  linkText: PropTypes.string,
  link: PropTypes.object,
}

export default ContentBox
